module.exports = __webpack_public_path__ + "img/offline_bolt.1d298b95.svg";